/**
 * 获取当前的基础路径
 * @returns string 例如: /abc 或 /urlb
 */
export function getBasePath(): string {
  const proxyHost = import.meta.env.VITE_PROXY_HOST
  const proxyPath = import.meta.env.VITE_PROXY_PATH
  if(window.location.hostname == proxyHost){
    return `/${proxyPath}`
  }
  return ''
}

/**
 * 获取完整的URL路径（包含基础路径）
 * @param path 相对路径
 * @returns string 例如: /abc/auth/login
 */
export function getFullPath(path: string): string {
  const basePath = getBasePath()
  return `${basePath}${path}`
}
